import React from 'react'
import { formatToCNPJ } from 'brazilian-values'

import styles from './styles'
import DisplayAnswerItems from './DisplayAnswerItems'

function DisplayProducts(props) {
  const { questionData } = props
  const classes = styles()

  const buildProduct = (productData) => {
    return (
      <div className={classes.answersContainer} key={productData.cnpj}>
        <p>
          <span>Razão social: </span>
          {productData.corporate_name}
        </p>
        <p>
          <span>CNPJ: </span>
          {formatToCNPJ(productData.cnpj)}
        </p>

        <p>
          <span>Descrição dos produtos oferecidos: </span>
          {productData.product_description}
        </p>
      </div>
    )
  }

  return (
    <div className={classes.root}>
      <h3>Produtos oferecidos:</h3>
      <DisplayAnswerItems
        answerData={questionData}
        noDataMessage="O assessor informou que não oferece ou trabalha em empresa que forneça produtos financeiros."
        funcBuildItem={buildProduct}
      />
    </div>
  )
}

export default DisplayProducts
